export { buildSdinDeclarationModule } from './build'

export type { SdinDeclarationModuleBuildingOptions } from './build'
